// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// ----- FR -----
import frCommon from "./locales/fr/common.json";
import frAbout from "./locales/fr/about.json";
import frHome from "./locales/fr/home.json";
import frSchedule from "./locales/fr/schedule.json";
import frCrew from "./locales/fr/crew.json";
import frRegistration from "./locales/fr/registration.json";
import frBlog from "./locales/fr/blog.json";
import frCancel from "./locales/fr/cancel.json";
import frPayment from "./locales/fr/payment.json";
import shopFR from './locales/fr/shop.json';
import paiementRetourFR from './locales/fr/paiementRetour.json';
import privacyFR from './locales/fr/privacy.json';

// ----- EN -----
import enCommon from "./locales/en/common.json";
import enAbout from "./locales/en/about.json";
import enHome from "./locales/en/home.json";
import enSchedule from "./locales/en/schedule.json";
import enCrew from "./locales/en/crew.json";
import enRegistration from "./locales/en/registration.json";
import enBlog from "./locales/en/blog.json";
import enCancel from "./locales/en/cancel.json";
import enPayment from "./locales/en/payment.json";
import shopEN from './locales/en/shop.json';  // ⬅️ IMPORT
import paiementRetourEN from './locales/en/paiementRetour.json';
import privacyEN from './locales/en/privacy.json';

// ----- NL -----
import nlCommon from "./locales/nl/common.json";
import nlAbout from "./locales/nl/about.json";
import nlHome from "./locales/nl/home.json";
import nlSchedule from "./locales/nl/schedule.json";
import nlCrew from "./locales/nl/crew.json";
import nlRegistration from "./locales/nl/registration.json";
import nlBlog from "./locales/nl/blog.json";
import nlCancel from "./locales/nl/cancel.json";
import nlPayment from "./locales/nl/payment.json";
import shopNL from './locales/nl/shop.json';
import paiementRetourNL from './locales/nl/paiementRetour.json';
import privacyNL from './locales/nl/privacy.json';

i18n
  .use(initReactI18next)
  .init({
    lng: "fr",
    fallbackLng: "fr",
    resources: {
      fr: {
        common: frCommon,
        about: frAbout,
        home: frHome,
        schedule: frSchedule,
        crew: frCrew,
        registration: frRegistration,
        blog: frBlog,
        cancel: frCancel,
        payment: frPayment, 
        shop: shopFR,  // ⬅️ CORRECT
        paiementRetour: paiementRetourFR,
        privacy: privacyFR,
      },
      en: {
        common: enCommon,
        about: enAbout,
        home: enHome,
        schedule: enSchedule,
        crew: enCrew,
        registration: enRegistration,
        blog: enBlog,
        cancel: enCancel,
        payment: enPayment, 
        shop: shopEN,  // ⬅️ CORRIGÉ (était "shopEN,")
        paiementRetour: paiementRetourEN,
        privacy: privacyEN,
      },
      nl: {
        common: nlCommon,
        about: nlAbout,
        home: nlHome,
        schedule: nlSchedule,
        crew: nlCrew,
        registration: nlRegistration,
        blog: nlBlog,
        cancel: nlCancel,
        payment: nlPayment, 
        shop: shopNL,  // ⬅️ CORRECT
        paiementRetour: paiementRetourNL,
        privacy: privacyNL,
      },
    },
    ns: [
      "common",
      "about",
      "home",
      "schedule",
      "crew",
      "registration",
      "blog",
      "cancel",
      "payment",
      "shop",
      "paiementRetour",
      "privacy"
    ],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    returnNull: false,
  });

export default i18n;